import TitleBar from "@components/Layout/TitleBar";
import HistoireDuClub from "@components/PageComponents/LeClub/Histoire";
import SEO from "@components/SEO";
import HOF from "@components/PageComponents/LeClub/HOF";
import Palmares from "@components/PageComponents/LeClub/Palmares";

import React from "react";
import { motion } from "framer-motion";
import { contentSlideUp, parent, transition } from "@services/motionTransitions";
import { NextPage } from "next";
import NosEngagements from "@components/PageComponents/LeClub/NosEngagements";
import Valeurs from "@components/PageComponents/LeClub/Valeurs";

const LeClub: NextPage = () => {
  return (
    <motion.div className="container-padding container-margin container" exit={{ opacity: 0 }}>
      <SEO
        pageTitle="Le club | DeathroW Esport"
        pageDescription="DeathroW est un club esport français, formateur de talents sur la scène Rainbow Six Siege. Decouvrez notre histoire et le chemin parcouru depuis 2019."
      />

      <TitleBar subtitle={"Qui sommes nous ?"}>Le club</TitleBar>
      <motion.div variants={parent} animate="animate" initial="initial" className="flex flex-col gap-y-28 md:gap-y-40">
        <motion.div variants={contentSlideUp} transition={transition}>
          <HistoireDuClub />
        </motion.div>
        <motion.div variants={contentSlideUp} transition={transition}>
          <NosEngagements />
        </motion.div>
        <motion.div variants={contentSlideUp} transition={transition}>
          <Valeurs />
        </motion.div>
        <motion.div variants={contentSlideUp} transition={transition}>
          <HOF />
        </motion.div>
        <motion.div variants={contentSlideUp} transition={transition}>
          <Palmares />
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default LeClub;
